import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47c6f7a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("New Display")
const _hoisted_2 = {
  class: "p-grid",
  style: {"flex-wrap":"nowrap"}
}
const _hoisted_3 = { class: "p-col" }
const _hoisted_4 = {
  class: "p-float-label",
  style: {"margin-top":"20px"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Name", -1))
const _hoisted_6 = {
  class: "p-mt-2",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Plaque dark mode ")
const _hoisted_8 = { class: "p-col" }
const _hoisted_9 = { style: {"display":"flex","align-items":"center"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_display_item = _resolveComponent("display-item")!
  const _component_TokenList = _resolveComponent("TokenList")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabView = _resolveComponent("TabView")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    header: "Header",
    visible: _ctx.display_id != null,
    modal: true,
    "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('update:display_id', null))),
    style: {"width":"100%","max-width":"700px","max-height":"100%"}
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        label: "Save",
        onClick: _ctx.handleSave
      }, null, 8, ["onClick"]),
      _createVNode(_component_Button, {
        class: "p-button-text",
        label: "Cancel",
        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('update:display_id', null)))
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, [
            _createVNode(_component_InputText, {
              id: "name",
              modelValue: _ctx.display.entity.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.display.entity.name) = $event)),
              type: "text",
              style: {"margin":"0 auto","max-width":"150px"}
            }, null, 8, ["modelValue"]),
            _hoisted_5
          ]),
          _createVNode(_component_Button, {
            class: "p-button-sm p-mt-2",
            label: "Open in browser",
            onClick: _ctx.openDisplayInBrowser,
            style: {"display":"block"}
          }, null, 8, ["onClick"]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_InputSwitch, {
              modelValue: _ctx.display.entity.plaque_dark_mode,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.display.entity.plaque_dark_mode) = $event)),
              class: "p-mr-2"
            }, null, 8, ["modelValue"]),
            _hoisted_7
          ]),
          _createVNode(_component_Button, {
            class: "p-button-danger p-button-sm p-mt-2",
            label: "Forget display",
            onClick: _ctx.forgetDisplay,
            style: {"display":"block"}
          }, null, 8, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_display_item, {
            name: _ctx.display.entity.name,
            token_id: _ctx.display.entity.token_id,
            asset_contract_address: _ctx.display.entity.asset_contract_address
          }, null, 8, ["name", "token_id", "asset_contract_address"]),
          _createElementVNode("div", _hoisted_9, [
            _createTextVNode(_toDisplayString(`${_ctx.display?.entity?.playlist_tokens?.length || 0} token${_ctx.display?.entity?.playlist_tokens?.length == 1 ? '' : 's'} in playlist`) + " ", 1),
            _createVNode(_component_Button, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.display.entity.playlist_tokens = [])),
              icon: "pi pi-times",
              class: "p-ml-2 p-button-rounded"
            })
          ])
        ])
      ]),
      _createVNode(_component_TabView, null, {
        default: _withCtx(() => [
          _createVNode(_component_TabPanel, { header: "Demo tokens" }, {
            default: _withCtx(() => [
              _createVNode(_component_TokenList, {
                selected_token_id: _ctx.display.entity.token_id,
                "onUpdate:selected_token_id": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.display.entity.token_id) = $event)),
                selected_asset_contract_address: _ctx.display.entity.asset_contract_address,
                "onUpdate:selected_asset_contract_address": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.display.entity.asset_contract_address) = $event)),
                playlist_tokens: _ctx.display.entity.playlist_tokens,
                "onUpdate:playlist_tokens": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.display.entity.playlist_tokens) = $event))
              }, null, 8, ["selected_token_id", "selected_asset_contract_address", "playlist_tokens"])
            ]),
            _: 1
          }),
          _createVNode(_component_TabPanel, { header: "My tokens" }, {
            default: _withCtx(() => [
              _createVNode(_component_TokenList, {
                selected_token_id: _ctx.display.entity.token_id,
                "onUpdate:selected_token_id": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.display.entity.token_id) = $event)),
                selected_asset_contract_address: _ctx.display.entity.asset_contract_address,
                "onUpdate:selected_asset_contract_address": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.display.entity.asset_contract_address) = $event)),
                playlist_tokens: _ctx.display.entity.playlist_tokens,
                "onUpdate:playlist_tokens": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.display.entity.playlist_tokens) = $event)),
                user_tokens: true
              }, null, 8, ["selected_token_id", "selected_asset_contract_address", "playlist_tokens"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["visible"]))
}